var map = {
	"./1.jpg": 1402,
	"./2-1.jpg": 6865,
	"./2-2.jpg": 7718,
	"./2.jpg": 7592,
	"./b-2-shape-1.png": 1991,
	"./b-2-shape-2.png": 9123,
	"./b-2-shape-3.png": 930,
	"./b-2-shape-4.png": 24,
	"./b-2-shape-5.png": 3568,
	"./b-2-shape-6.png": 9682,
	"./b-3-shape.png": 5771,
	"./banner-bg-shape-3.png": 2310,
	"./banner-bg.jpg": 6770,
	"./banner-bottom-1.png": 9751,
	"./banner-bottom-2.png": 9409,
	"./bg-1.jpg": 4716,
	"./bg-2.jpg": 8354,
	"./bg-3.jpg": 228,
	"./bg-4.jpg": 8852,
	"./image-1.jpg": 7841,
	"./left-curve-line.png": 8071,
	"./old/1.jpg": 1536,
	"./old/2-1.jpg": 4088,
	"./old/2-2.jpg": 6191,
	"./old/2.jpg": 2958,
	"./right-curved-bg.png": 6510,
	"./right-white-curve.png": 2693,
	"./slide-2-pattern-1.png": 9985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7085;